import * as parser from "@tmcw/togeojson";

export const parseKml = async (file: File) => {
  return parser.kml(new DOMParser().parseFromString(await file.text(), "text/xml"));
};
